import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center flex-col p-4"
};
const _hoisted_2 = {
  class: "text-2xl"
};
import { NeutralIncidentTypeEnum } from "@/modules/match/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'NeutralIncident',
  props: {
    liveIncident: null
  },
  setup(__props) {
    const props = __props;
    const labelMap = {
      [NeutralIncidentTypeEnum.START]: 'start_regular_time',
      [NeutralIncidentTypeEnum.END]: 'end_regular_time',
      [NeutralIncidentTypeEnum.START_EXTRA_TIME]: 'start_extra_time',
      [NeutralIncidentTypeEnum.END_EXTRA_TIME]: 'end_extra_time',
      [NeutralIncidentTypeEnum.NOT_ENOUGH_PlAYERS]: 'not_enough_players',
      [NeutralIncidentTypeEnum.START_PENALTY]: 'start_penalty',
      [NeutralIncidentTypeEnum.END_PENALTY]: 'end_penalty'
    };
    const label = ref(labelMap[props.liveIncident.incident.neutralType]);
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Icon, {
        icon: _ctx.IconEnum.Whistle,
        size: "4rem"
      }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(label.value)), 1)]);
    };
  }
});